var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import OriginalMaterialTable, { MTableAction, } from '@material-table/core';
import { Link } from '@mui/material';
import icons from './icons';
import EditField from './EditField';
import Cell from './Cell';
import { DetailsIcon } from '../atoms/Icons';
import { setSort, getSort } from '../../localStorage';
import DefaultFilter from './DefaultFilter';
var MaterialTable = function (_a) {
    var model = _a.model, detailPath = _a.detailPath, _b = _a.emptyValue, emptyValue = _b === void 0 ? '' : _b, sortSaveKey = _a.sortSaveKey, originalProps = __rest(_a, ["model", "detailPath", "emptyValue", "sortSaveKey"]);
    var t = useTranslation().t;
    var navigate = useNavigate();
    var actions = originalProps.actions, columns = originalProps.columns, options = originalProps.options, components = originalProps.components, onOrderChange = originalProps.onOrderChange, title = originalProps.title, otherProps = __rest(originalProps, ["actions", "columns", "options", "components", "onOrderChange", "title"]);
    var originalDefaultFilter = React.useCallback(function (props) { return React.createElement(DefaultFilter, __assign({}, props)); }, []);
    var customColumns = columns.map(function (column) {
        var _a;
        return (__assign({ title: t("params.".concat(model, ".").concat(String(column.field)), '') ||
                t("params.".concat(String(column.field))), emptyValue: column.field && emptyValue, filterComponent: ((_a = column.type) !== null && _a !== void 0 ? _a : 'string') === 'string' && !column.lookup
                ? originalDefaultFilter
                : undefined }, column));
    });
    var sort = sortSaveKey && getSort(sortSaveKey);
    if (sort) {
        var sortColumn = customColumns[sort.order];
        if (sortColumn)
            sortColumn.defaultSort = sort.direction;
    }
    var handleOrderChanged = React.useCallback(function (order, direction) {
        if (sortSaveKey)
            setSort(sortSaveKey, { order: order, direction: direction });
        if (onOrderChange)
            onOrderChange(order, direction);
    }, [sortSaveKey, onOrderChange]);
    var useToolbar = React.useMemo(function () {
        if (title) {
            return true;
        }
        if (otherProps.editable && otherProps.editable.onRowAdd) {
            return true;
        }
        return false;
    }, [otherProps.editable, title]);
    var customActions = React.useMemo(function () {
        var result = [];
        if (detailPath) {
            result.push({
                icon: function () { return React.createElement(DetailsIcon, null); },
                onClick: function (e, row) {
                    e.preventDefault();
                    navigate(detailPath(row));
                },
                tooltip: t('detail'),
                isLink: true,
            });
        }
        return result.concat(actions || []);
    }, [actions, detailPath, t, navigate]);
    return (React.createElement(OriginalMaterialTable, __assign({ actions: customActions, columns: customColumns, icons: icons, localization: {
            header: {
                actions: '',
            },
            body: {
                emptyDataSourceMessage: t('labels.noData'),
                editRow: {
                    deleteText: t('messages.deleteConfirm'),
                },
            },
            toolbar: {
                nRowsSelected: t('messages.nRowsSelected'),
            },
        }, components: __assign({ Cell: Cell, EditField: EditField, Action: function (props) {
                return detailPath && props.action.isLink ? (React.createElement(Link, { href: detailPath(props.data) },
                    React.createElement(MTableAction, __assign({}, props)))) : (React.createElement(MTableAction, __assign({}, props)));
            } }, components), options: __assign({ toolbar: useToolbar, paging: false, search: false, pageSize: 25, pageSizeOptions: [25, 50, 100, 500], minBodyHeight: 300, headerStyle: {
                whiteSpace: 'nowrap',
            }, draggable: false }, options), onOrderChange: handleOrderChanged, title: title || '' }, otherProps)));
};
export default MaterialTable;
